import(/* webpackMode: "eager", webpackExports: ["RollingMarketTicker"] */ "/opt/buildhome/repo/components/auth/rolling-market-ticker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthSwitchLink","LoginPageClient"] */ "/opt/buildhome/repo/components/forms/login-page.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReferralCodeField"] */ "/opt/buildhome/repo/components/forms/referral-code-field.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchParamsProvider"] */ "/opt/buildhome/repo/components/search-params-provider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@14.2.5_@opentelemetry+api@1.10.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/node_modules/.pnpm/next@14.2.5_@opentelemetry+api@1.10.0_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/dist/client/link.js");
